import React from "react";
var __jsx = React.createElement;
import ContactForm from "./Components/ContactForm/ContactForm";
import ContactMap from "./Components/ContactMap/ContactMap";
import AnyQustV2 from "@/pages/homePageV2/homePageComponents/components/AnyQust/AnyQustV2";
import stl from "./ContactComponent.module.css";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useIsMobile from "@hooks/useIsMobile";
var ContactComponent = function ContactComponent() {
  var location = useLocation();
  var isMobile = useIsMobile();
  useEffect(function () {
    if (!isMobile) return;
    var params = new URLSearchParams(location.search);
    if (params.get("scrollTo") === "contact-map") {
      setTimeout(function () {
        var _document$getElementB;
        (_document$getElementB = document.getElementById("contact-map")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.scrollIntoView({
          behavior: "smooth"
        });
      }, 0);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.contactSection].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement(ContactForm, null), /*#__PURE__*/React.createElement(ContactMap, null)), /*#__PURE__*/React.createElement("div", {
    className: stl.anyQustWrapper
  }, /*#__PURE__*/React.createElement(AnyQustV2, {
    isContactUs: true,
    hasSocialLinks: true
  })));
};
export default ContactComponent;